import CardLoader from "./CardLoader";
import "./shimmer.css";

const DashboardLoader = () => (
  <div className="shimmer-dashboard-loader">
    <div className="shimmer-dashboard-filters">
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className="shimmer-block" />
      ))}
    </div>
    <CardLoader count={4} />
    <div className="shimmer-block shimmer-dashboard-chart" />
  </div>
);

export default DashboardLoader;
